import { FuturesSymbolWithMarket } from '@hub/services/entities/futures-symbols-service';
import { fetchSupportedFuturesSymbols } from '@hub/utils/react-query/query-functions';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_QUERY_KEYS, ACCOUNT_STALE_TIME } from '../constants';

export const useSupportedSymbolsData = (enabled = true) => {
  return useQuery<FuturesSymbolWithMarket[]>({
    queryKey: ACCOUNT_QUERY_KEYS.SUPPORTED_SYMBOLS,
    queryFn: fetchSupportedFuturesSymbols,
    staleTime: ACCOUNT_STALE_TIME,
    enabled,
  });
};
